<h5>Twitter API
    <img src="../../../assets/media/twitter-logo.png" title="Twitter"/>
    <img src="../../../assets/media/aspnetcore-logo.png" title=".NetCore"/>
</h5>
<P>Main purpose here is to show I can use basic authorization to get data from outside vendors, in this case Twitter.</P>
<P>I am getting all this data from my backend API in the Twitter Controller.  I actually built another for search by GeoLocations that I was going to use with the map but felt like it would be overkill.</P>
